import React from 'react';
import CityLandingPage from '../CityLandingPage/CityLandingPage';
import { cityContent } from '../../data/cityLandingContent';

const LandingPageGranCanaria = props => {
  return <CityLandingPage cityKey="GranCanaria" cityConfig={cityContent.granCanaria} {...props} />;
};

export default LandingPageGranCanaria;
